import React from 'react'
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { IoIosArrowForward } from "react-icons/io";
import { FaArrowLeft } from 'react-icons/fa'
import { FaAddressBook } from "react-icons/fa";
import { FaAddressCard } from "react-icons/fa";
import { FaIdCardAlt } from "react-icons/fa";
import { FaIdBadge } from "react-icons/fa6";
import { PiPhoneCallFill } from "react-icons/pi";
import SMSReport from './SMSReport';
import RCSReport from './RCSReport';
import WHATSAPPReport from './WHATSAPPReport';
import VoiceReport from './VoiceReport';
import IVRreport from './IVRreport';

function ReportsDownload() {

    const [activeTab, setActiveTab] = useState("SMSStatistics");

    const tabList = [
        {
            id: "SMSStatistics", label: "SMS ", icon: <FaAddressBook />
            , component: <SMSReport />
        },
        {
            id: "RCSStatistics", label: "RCS ", icon: <FaAddressCard />
            , component: <RCSReport />
        },
        {
            id: "WhatsAppStatistics", label: "WhatsApp ", icon: <FaIdCardAlt />
            , component: <WHATSAPPReport />
        },
        {
            id: "VoiceStatistics", label: "Voice ", icon: <PiPhoneCallFill />
            , component: <VoiceReport/>
        },
        {
            id: "TTSStatistics", label: "IVR", icon: <FaIdBadge />
            , component: <IVRreport/>
        }
    ];




    return (
        <>
            <div className='dark:bg-[#121519] min-h-screen md:pt-[70px] pt-[100px] '>
                <div className='w-[100%] px-4'>
                    <div className='pb-1 flex items-center gap-2 '>
                        <Link to='/WAMessage/UserChatBox'>
                            <FaArrowLeft className='text-[18px] dark:text-[#fff]' />
                        </Link>
                        <div>
                            <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>Reports Download</h1>
                            <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>  <span>Home</span> <IoIosArrowForward /> <span>Report Download</span>  </div>
                        </div>
                    </div>
                    <div className='w-[100%] shadow-[0_2px_8px_rgba(0,0,0,0.1)] px-2 rounded-lg pt-1  pb-6'>
                        <div className=' w-[100%] flex gap-1  border-[#e0e0e0]  border-b-[1px] pb-1'>
                            {tabList.map((item, index) =>
                                <button
                                    onClick={() => setActiveTab(item.id)}
                                    className={` w-[20%] rounded-t-[5px]  py-2 text-[11px] font-bold flex items-center justify-center gap-1 ${activeTab === item.id ? 'bg-[#37715d] text-[#fff]' : 'bg-[#e0e0e0] text-[#333]'} `} > {item.icon}  <span className='md:block hidden'>{item.label}</span>  </button>
                            )
                            }
                        </div>
                    </div>
                    <div className="pt-4  dark:bg-[#121519]">
                        {tabList.find((t) => t.id === activeTab)?.component}
                    </div>
                </div>
            </div>
        </>
    )
}

export default ReportsDownload
